import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CoreDialog",
    {
      attrs: {
        "data-qa": "appointment-error-modal",
        size: "sm",
        persistent: _vm.errorData.isPersistent,
        title: _vm.$t(_vm.errorData.title, {
          ..._vm.options,
          daily_limit: _vm.dailyLimit,
        }),
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _vm.currentActions.buttonFirst
                ? _c(
                    VBtn,
                    _vm._g(
                      {
                        attrs: {
                          "data-qa": "modal-actions-btn-close",
                          text: "",
                          color: "black",
                        },
                        on: { click: _vm.handleClickButtonFirst },
                      },
                      _vm.currentActions.buttonFirst.on
                    ),
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              _vm.currentActions.buttonFirst.text,
                              _vm.options
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentActions.buttonSecond
                ? _c(
                    VBtn,
                    _vm._g(
                      {
                        attrs: {
                          "data-qa": "modal-actions-btn-confirm",
                          text: "",
                          color: "primary",
                        },
                        on: { click: _vm.handleClickButtonSecond },
                      },
                      _vm.currentActions.buttonSecond.on
                    ),
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              _vm.currentActions.buttonSecond.text,
                              _vm.options
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.isVisibleDialog,
        callback: function ($$v) {
          _vm.isVisibleDialog = $$v
        },
        expression: "isVisibleDialog",
      },
    },
    [
      _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t(_vm.errorData.subtitle, _vm.options)) +
            "\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }